import React from 'react';

import './style.scss'; // 引入样式文件

const Toast = ({ message, duration, position }) => {
  const styleObj = position === "top" ? 
  { 
    animationDuration: `${duration}ms`, 
    top: "20%" , 
  } : position === "bottom" ? { 
    animationDuration: `${duration}ms`, 
    top: "unset",
    bottom: "15%",
  } : {
    animationDuration: `${duration}ms`, 
    top: "50%", 
    transform: "translate(-50%, -50%)",
  }
  return (
    <div className="toast" style={styleObj}>
      {message}
    </div>
  );
};
export default Toast;